// src/partners/adminPartnersApi.ts
import { apiClient } from "@maat/api-base";
var adminPartnersApi = {
  list: async (params) => {
    return apiClient.get("/main/api/admin/partners", { params });
  },
  get: async (id) => {
    return apiClient.get(`/main/api/admin/partners/${id}`);
  },
  create: async (data) => {
    return apiClient.post("/main/api/admin/partners", data);
  },
  update: async (id, data) => {
    return apiClient.patch(`/main/api/admin/partners/${id}`, data);
  },
  createLink: async (partnerId, data) => {
    return apiClient.post(`/main/api/admin/partners/${partnerId}/links`, data);
  },
  /** One link per channel in one request; duplicates come back in `skipped`. */
  createLinksBulk: async (partnerId, data) => {
    return apiClient.post(`/main/api/admin/partners/${partnerId}/links/bulk`, data);
  },
  updateLink: async (partnerId, linkId, data) => {
    return apiClient.patch(`/main/api/admin/partners/${partnerId}/links/${linkId}`, data);
  },
  linkQr: async (partnerId, linkId) => {
    return apiClient.get(`/main/api/admin/partners/${partnerId}/links/${linkId}/qr`);
  },
  stats: async (id, params) => {
    return apiClient.get(`/main/api/admin/partners/${id}/stats`, { params });
  },
  listApplications: async (params) => {
    return apiClient.get("/main/api/admin/partner-applications", { params });
  },
  reviewApplication: async (id, data) => {
    return apiClient.patch(`/main/api/admin/partner-applications/${id}`, data);
  },
  /** Partners with OPEN self-referral fraud flags (Action Required source). */
  fraudFlags: async () => {
    return apiClient.get("/main/api/admin/partners/fraud-flags");
  },
  /**
   * Close a flag. `resolution` defaults server-side to DISMISS; the override
   * values are only accepted for a `partner_ip_match` flag.
   */
  reviewFraudFlag: async (id, resolution = "DISMISS") => {
    return apiClient.patch(`/main/api/admin/partners/fraud-flags/${id}`, { resolution });
  },
  /** The partner's whole funnel by day — the detail page's chart. */
  timeseries: async (partnerId, params) => {
    return apiClient.get(`/main/api/admin/partners/${partnerId}/timeseries`, { params });
  },
  /** One link's daily funnel, with revenue — the admin per-link chart. */
  linkTimeseries: async (partnerId, linkId, params) => {
    return apiClient.get(`/main/api/admin/partners/${partnerId}/links/${linkId}/timeseries`, {
      params
    });
  },
  /** Every conversion the partner produced, paged. */
  conversions: async (partnerId, params) => {
    return apiClient.get(`/main/api/admin/partners/${partnerId}/conversions`, { params });
  },
  /** One link's conversions, paged — carries the guest and the booking. */
  linkConversions: async (partnerId, linkId, params) => {
    return apiClient.get(`/main/api/admin/partners/${partnerId}/links/${linkId}/conversions`, {
      params
    });
  }
};

export {
  adminPartnersApi
};
